import { jsx as t } from "react/jsx-runtime";
import { Avatar as i } from "../../Avatar/index.js";
import { Icon as c } from "../../Icon/index.js";
import '../../../assets/index40.css';const m = "_itemDecorationLeft_wzdwl_1", r = {
  itemDecorationLeft: m
}, l = ({ avatarProps: o, iconProps: e }) => o ? /* @__PURE__ */ t("div", { className: r.itemDecorationLeft, children: /* @__PURE__ */ t(i, { ...o }) }) : e ? /* @__PURE__ */ t("div", { className: r.itemDecorationLeft, children: /* @__PURE__ */ t(c, { ...e, color: e.color ?? "moon" }) }) : null;
export {
  l as ItemDecorationLeft
};
//# sourceMappingURL=index.js.map
